import { useEffect } from "react";
import * as yup from "yup";

import { View } from "./View";
import {
  useApiErrors,
  useAuth,
  useHookForm,
  useIdentityMutation,
  useNotifications,
} from "../../hooks";
import { IChangePasswordRequest } from "../../interfaces-and-types";
import { getApiErrorsByFieldName, globalHandlerUtils } from "../../utils";
import { useNavigate } from "react-router-dom";

export const ChangePassword = () => {
  const navigate = useNavigate();
  const { signOut } = useAuth();
  const notificationsHandler = useNotifications();

  const { isSuccess, mutate: resetPassword } = useIdentityMutation<
    IChangePasswordRequest,
    void
  >("changePassword").usePostMutation;

  useEffect(() => {
    if (isSuccess) {
      reset();

      notificationsHandler.showNotification({
        ariaLabel: "error notification",
        title: "Password Changed Successfully",
        kind: "success",
        message:
          "Your password was successfully changed. Please login to your account with your new password.",
        statusIconDescription: "error",
        timeout: 15000,
      });

      setTimeout(() => {
        signOut();
        redirectToLogin();
      }, 4000);
    }
  }, [isSuccess]);

  const { apiErrors } = useApiErrors();

  const redirectToLogin = () => navigate("/login");

  const initialFormValues: IChangePasswordRequest = {
    current_password: "",
    new_password: "",
    new_password_confirmation: "",
  };

  const confirmEmailSchema: yup.SchemaOf<IChangePasswordRequest> = yup
    .object({
      current_password: yup.string().required(),
      new_password: yup.string().required(),
      new_password_confirmation: yup
        .string()
        .oneOf(
          [yup.ref("new_password"), null],
          "Password and confirmation must match"
        )
        .required("Password confirmation is required"),
    })
    .required();

  const handleApiSubmit = (data: IChangePasswordRequest) => {
    resetPassword(data);
  };

  const handleError = (errors: any) => globalHandlerUtils.handleError(errors);

  const { onFormSubmit, errors, register, reset, watch } = useHookForm({
    initialFormValues,
    validationSchema: confirmEmailSchema,
    onValid: handleApiSubmit,
    onInvalid: handleError,
  });

  // const mismatchErrorMessage = getApiErrorsByFieldName(
  //   "password_mismatch",
  //   apiErrors
  // );

  return (
    <View
      isModalOpen
      closeModal={() => navigate("/settings")}
      passwordResetSuccessful={isSuccess}
      redirectToLogin={redirectToLogin}
      // mismatchErrorMessage={mismatchErrorMessage}
      handleSubmit={onFormSubmit}
      register={register}
      errors={errors}
    />
  );
};
